import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalItemPasteStateService {
  private _isModalItemPasteState = signal<number | null>(null);
  public isModalItemPasteState = this._isModalItemPasteState.asReadonly();

  public setIsModalItemPasteState(recordId: number) {
    const test = this.isModalItemPasteStateByRecordId(recordId);
    this._isModalItemPasteState.set(test ? null : recordId);
  }

  public isModalItemPasteStateByRecordId(recordId: number): boolean {
    return this.isModalItemPasteState() === recordId;
  }
}
